<template>
  <div id="adminproductorderquotes">
    <div class="pa-2">
      <v-row justify="space-between">
        <v-col cols="12" md="12">
          <ProductOrderQuotes />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script lang="ts">
import ProductOrderQuotes from "@/components/admin-components/global/ProductOrderQuotes.vue";

export default {
  name: "AdminProductOrderQuotesView",
  components: { ProductOrderQuotes },
  data: () => ({}),
};
</script>
